import { ITrainingCategoryValues } from './training-category-form-types'
import {
  ITrainingCategory,
  ITrainingCategoryUpsert,
} from '../../../../interfaces'

export const trainingCategoryToTrainingCategoryValues = (
  trainingCategory: ITrainingCategory | undefined,
): ITrainingCategoryValues | undefined => {
  if (!trainingCategory) {
    return undefined
  }

  return {
    name: trainingCategory?.name,
    sortOrder: String(trainingCategory?.sortOrder),
    isActive: trainingCategory?.isActive,
  }
}

export const trainingCategoryValuesToTrainingCategoryAddUpsert = (
  trainingCategoryValues: ITrainingCategoryValues,
): ITrainingCategoryUpsert | undefined => {
  if (!trainingCategoryValues) {
    return undefined
  }

  return {
    name: trainingCategoryValues?.name,
    sortOrder: trainingCategoryValues?.sortOrder || '0',
    isActive: trainingCategoryValues?.isActive || false,
  }
}

export const trainingCategoryValuesToTrainingCategoryUpdateUpsert = (
  trainingCategoryValues: ITrainingCategoryValues,
  trainingCategory: ITrainingCategory,
): ITrainingCategoryUpsert | undefined => {
  if (!trainingCategoryValues || !trainingCategory?.id) {
    return undefined
  }

  return {
    id: trainingCategory.id,
    name: trainingCategoryValues?.name,
    sortOrder: trainingCategoryValues?.sortOrder,
    isActive: trainingCategoryValues?.isActive,
  }
}